import { render, staticRenderFns } from "./RemoteNumberModal.vue?vue&type=template&id=0b56e59f&scoped=true"
import script from "./RemoteNumberModal.vue?vue&type=script&lang=js"
export * from "./RemoteNumberModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b56e59f",
  null
  
)

export default component.exports